function _submitKlavio2(event) {
  const email = $('#back-in-email').val();
  $.ajax({
    type: "POST",
    url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
    data: {
      a: "gNKg4J",
      email,
      variant: app.currentVariant.id,
      product: app.product.id,  // Product must be present in Klaviyo catalog to record event.
      platform: "shopify",
      subscribe_for_newsletter: false,  // Optional with "g". Defaults to false if omitted.
    },
    // eslint-disable-next-line object-shorthand
    success: function(response) {

      if (response != undefined && response.success == true) {
        app.backInStockDone = true;
        app.backInStockerror = false;            
      } else {
        app.backInStockerror = true;
        app.backInStockDone = false;
      }
    }
  });
}